





































import {Component, Vue} from "vue-property-decorator";
import LadingSelector from "@/shared/components/LadingSelector/index.vue";
import {LadingStatus} from "@/enums/status";
import {FormModel} from "ant-design-vue";
import {LadingErrorStore} from "@/modules/ladingerror/store";

@Component({
    name: "LadingErrorCreate",
    components: {LadingSelector}
})
export default class extends Vue {
    LadingStatus = LadingStatus
    
    private form = {
        ladingCode: "",
        note: ""
    };
    private rules = {
        ladingCode: [{required: true, message: "Nhập mã vận đơn", trigger: "change"}],
        note: [{required: true, message: "Nhập nội dung sự cố", trigger: "change"}]
    }
    
    private onSubmit() {
        (this.$refs.formLadingError as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                await LadingErrorStore.createLadingError(this.form)
                this.$notification.success({
                    message: "Thành công",
                    description: `Tạo đơn sự cố thành công`
                });
                
            } catch (e) {
                this.$notification.error({
                    message: "Thất bại",
                    description: `${e.response?.data?.message || 'Tạo đơn sự cố thất bại'}`
                })
            }
            
        })
    }
}


